import React from "react";
import {StaticFieldDisplayProps} from "../staticFieldUtils.ts";
import {
    FormLabel, getInputWrapperClass,
} from "../../sharedStyles.tsx";



const StaticCheckboxRenderer: React.FC<StaticFieldDisplayProps> = ({ component, value }) => {
    return (
        <div className={getInputWrapperClass(component)}>
            {/* Custom checkbox */}
            <div
                className='flex items-start gap-3 p-2 mt-1 w-full rounded-md px-1.5 py-1 bg-gray-50 text-xs shadow-sm border border-gray-300  text-gray-900'>
                {value === true ?
                    <div
                        className='h-4 w-4 rounded border flex items-center justify-center mt-0.5 border-gray-500 bg-gray-500'></div>
                    :
                    <div
                        className='h-4 w-4 rounded border flex items-center justify-center mt-0.5 border-gray-300 bg-gray-50'></div>
                }
                <FormLabel component={component} classOverride={"text-xs"}/>

            </div>
            {component.description && (
                <div className="flex flex-col">
                    <div className="text-sm text-gray-500">{component.description}</div>
                </div>
            )}
        </div>
    );
};
export const StaticCheckbox = React.memo(StaticCheckboxRenderer);